angular.module("questionarioAdv.module")
  .component("esecutore", {
    templateUrl: "ng/components/questionarioAdv/esecutore/esecutore.view.html",
    bindings: {
      model: "=",
      exportValidationComponent: '&',
      newExecutAddFn: '&',
      domini: '<',
      resetSupportModel: '<',
      startQuestionario: '<',
      isPagoDopo: '<',
      listaNazioni: '<',
      submitError: '<'
    },
    controllerAs: 'esecutoreCtrl',
    controller: Esecutore
  })

function Esecutore(
  $istatService,
  $rootScope,
  $typeDomainService,
  $scope,
  Documento,
  $timeout,
  $configService,
  Sede,
  validationService,
  $financialApiService,
  $modalService,
  FileUploader,
  $simulationService,
  $userService,
  $portalService,
  Pf,
  $instantService,
  $uniService,
  $download
) {
  var self = this;

  self.$onInit = function () {
    self.dealerUser = {};
    self.mapComuni = $rootScope.comuniMap;
    self.documentUpload = [];
    self.testDati = [];
    self.uploadDocumentSelect = "upload"
    self.linkPep = '/uni/download/service-infos/' +
      encodeURIComponent('GLOSSARIO') + '/';
    self.validationObj = {
      documentDate: {
        disabledDays: [0],
        disabledDates: [
          "01-01",
          "06-01",
          "25-04",
          "01-05",
          "02-06",
          "15-08",
          "01-11",
          "08-12",
          "25-12",
          "26-12"
        ]
      }
    };
    self.cfIsNotRequired = [];
    self.listaNomeRilascio = [];
    self.listaNomeRilascioNew = [];
    self.listaComuniNascita = [];
    self.newExecutAdded = self.model.filter(function (element) {
      return !element.ndg
    });
    self.newExecutAdded.forEach(function (element, index) {
      self.listaComuniNascita[index] = self.mapComuni
        .filter(function (comune) {
          return comune.sigla == element.datiNascita.provincia;
        });

      self.listaNomeRilascioNew[index] = element.documento && element.documento.tipo && Documento.getEntiRilascio(
        element.documento.tipo
      );
      if (element.datiNascita.provincia && element.datiNascita.provincia.toUpperCase() != 'EE' && element.datiNascita.provincia.toUpperCase() != 'SE') {
        self.verifyDate(index, true)
      }
    })
    self.model = self.model.filter(function (element) {
      return element.ndg
    });
    self.model.forEach(function (element, index) {
      if (element && !element.documento) {
        element.documento = Documento.build();
      }
      self.listaNomeRilascio[index] = element.documento && element.documento.tipo && Documento.getEntiRilascio(
        element.documento.tipo
      );
    })
    self.today = self.getTodaysDate();
    self.modelCopied = self.model && self.model[0];
    self.model && self.model.forEach(function (element) {
      if (element && element.sedeLegale && element.sedeLegale.stato) {
        element.sedeLegale.stato.name = element.sedeLegale.stato.name && element.sedeLegale.stato.name.toUpperCase();
      }
    })
    self.dropdown = {
      tipiDocumento: []
    }
    self.tomorrow = moment()
      .add(1, "days")
      .format("DD/MM/YYYY");
    self.listaNomeComuni = {
      rilascio: [],
      rilascioNew: []
    }
    self.supportModel = {
      ruolo: [],
      caricaIstituzionale: [],
      relazionePep: [],
      originePatrimonio: []
    }
    self.supportnewExecutAdded = {
      ruolo: [],
      caricaIstituzionale: [],
      relazionePep: [],
      originePatrimonio: []
    }
    getListaProvince();
    getListaDocumenti();
    setDefaulValue();
    validateComponent();
  }

  self.downloadLinkPep = () => {

    $download.getGenericDownload(self.linkPep)
      .then(function (response) {
        console.log(response);
      })
  }

  self.$onChanges = function (changed) {
    if (changed && changed.resetSupportModel && typeof changed.resetSupportModel.currentValue != "undefined") {
      self.newExecutAdded = [];
    }

    if (changed && changed.listaNazioni && changed.listaNazioni.currentValue) {
      self.nationCitizenship = self.listaNazioni.filter(
        function (element) {
          return !element.deleted
        }).map(function (element) {
          return element.name.toUpperCase();
        }).sort();
    }

    if (changed && changed.submitError && typeof changed.submitError.currentValue != "undefined") {
      ricreaModelli();
    }
  }

  self.handleChange = function (tipo, subType, valueSelected, indice, tipologia) {
    if (tipologia === 'executAdded') {
      if (subType) {
        self.newExecutAdded[indice][tipo][subType].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })

      } else {
        self.newExecutAdded[indice][tipo].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })
      }
    } else {
      if (subType) {
        self.model[indice][tipo][subType].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })
      } else {
        self.model[indice][tipo].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })
      }
    }
    validateComponent();
  }

  var getListaDocumenti = function () {

    $typeDomainService
      .getDomainSet("RI_DROPDOWN_DOMAINS", "DOCUMENT_TYPE")
      .then(function (response) {
        self.dropdown.tipiDocumento = response.domainList;
        for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
          if (self.dropdown.tipiDocumento[i].value == "CAE") {
            self.dropdown.tipiDocumento[i].order = 40;
          }
          if (self.dropdown.tipiDocumento[i].value == "CAI") {
            self.dropdown.tipiDocumento[i].order = 10;
          }
          if (self.dropdown.tipiDocumento[i].value == "CIE") {
            self.dropdown.tipiDocumento[i].order = 20;
          }
          if (self.dropdown.tipiDocumento[i].value == "NCE") {
            self.dropdown.tipiDocumento[i].order = 30;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAM") {
            self.dropdown.tipiDocumento[i].order = 50;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAS") {
            self.dropdown.tipiDocumento[i].order = 80;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAT") {
            self.dropdown.tipiDocumento[i].order = 60;
          }
          if (self.dropdown.tipiDocumento[i].value == "UCO") {
            self.dropdown.tipiDocumento[i].order = 70;
          }

        }
      });
  }


  self.getTodaysDate = function () {

    return moment().format("DD/MM/YYYY");
  }

  self.setDocNumRegex = function (indice, tipo) {

    if (tipo === 'executAdded') {
      self.listaNomeRilascioNew[indice] = Documento.getEntiRilascio(
        self.newExecutAdded[indice].documento.tipo
      );
      self.newExecutAdded[indice].documento.numero = null;
    } else {
      self.listaNomeRilascio[indice] = Documento.getEntiRilascio(
        self.model[indice].documento.tipo
      );
      self.model[indice].documento.numero = null;
    }
    self.refreshRegex = true;
    $timeout(function () {
      self.refreshRegex = false;
      validateComponent();
    }, 200)

    if (tipo === 'executAdded' && self.newExecutAdded[indice].ndg && !self.isPagoDopo) {
      $financialApiService
        .getIdentityDocument(
          self.newExecutAdded[indice].ndg,
          self.newExecutAdded[indice].documento.tipo
        )
        .then(function (response) {
          if (response.success) {
            self.newExecutAdded[indice].documento.dataRilascio =
              response.document.dataRilascio;
            self.newExecutAdded[indice].documento.dataScadenza =
              response.document.dataScadenza;
            self.newExecutAdded[indice].documento.luogoEsteso = {
              nome: response.document.luogo,
            };
            self.newExecutAdded[indice].documento.enteRilascio.name =
              response.document.enteRilascio;
            self.newExecutAdded[indice].documento.provincia =
              response.document.provincia;
            self.newExecutAdded[indice].documento.numero = response.document.numero;
            self.newExecutAdded[indice].documento.id = response.document.id;
          }
          $timeout(function () {
            validateComponent();
          }, 1000)
        })
        .catch(function (error) {
          console.log(error);
        });

    } else if (self.model && self.model[indice] && self.model[indice].ndg && tipo != 'executAdded' && !self.isPagoDopo) {
      $financialApiService
        .getIdentityDocument(
          self.model[indice].ndg,
          self.model[indice].documento.tipo
        )
        .then(function (response) {
          if (response.success) {
            self.model[indice].documento = Documento.build({
              tipo: self.model[indice].documento.tipo
            })
            self.model[indice].documento.dataRilascio =
              response.document.dataRilascio;
            self.model[indice].documento.dataScadenza =
              response.document.dataScadenza;
            self.model[indice].documento.luogoEsteso = {
              nome: response.document.luogo,
            };
            self.model[indice].documento.enteRilascio.name =
              response.document.enteRilascio;
            self.model[indice].documento.provincia =
              response.document.provincia;
            self.model[indice].documento.numero = response.document.numero;
            self.model[indice].documento.id = response.document.id;
          }
          $timeout(function () {
            validateComponent();
          }, 1000)
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      switch (tipo) {
        case 'executAdded':
          self.newExecutAdded[indice].documento = Documento.build({
            tipo: self.newExecutAdded[indice].documento.tipo
          });
          break;
        default:
          self.model[indice].documento = Documento.build({
            tipo: self.model[indice].documento.tipo
          });
      }
    }
  }

  var getListaProvince = function () {
    self.listaProvince = self.mapComuni
      .map(function (comune) {
        return comune.sigla;
      })
      .filter(function (siglaComune) {
        return siglaComune != "";
      })
      .sort()
      .reduce(function (result, nextItem) {
        return result.includes(nextItem) ? result : result.concat(nextItem);
      }, []);
    self.listaProvince.push("EE");

  }

  self.creaComuni = function (tipo, provincia, indice) {

    if (provincia != 'EE') {
      self.listaNomeComuni[tipo][indice] = self.mapComuni
        .filter(function (comune) {
          return comune.sigla == provincia;
        });
    }

    validateComponent();
  }

  self.radioModify = function (tipo, valore, indice) {
    if (tipo == 'pep') {
      if (!valore) {
        self.supportModel.caricaIstituzionale[indice] = null;
        self.supportModel.relazionePep[indice] = null;
      }

      self.model[indice].pep.carica.forEach(function (element) {
        element.selected = false;
      })

      self.model[indice].pep.relazione.forEach(function (element) {
        element.selected = false;
      })
    }
    validateComponent();
  }

  self.radioModifyNewExecut = function (tipo, valore, indice) {
    if (tipo == 'pep') {
      if (!valore) {
        self.supportnewExecutAdded.caricaIstituzionale[indice] = null;
        self.supportnewExecutAdded.relazionePep[indice] = null;
      }

      self.newExecutAdded[indice].pep.carica.forEach(function (element) {
        element.selected = false;
      })

      self.newExecutAdded[indice].pep.relazione.forEach(function (element) {
        element.selected = false;
      })
    }
    validateComponent();
  }

  var validateComponent = function () {
    $timeout(function () {

      var checkFileIsUploadedModel = self.model.every(function (element) {
        return (element.documento &&
          element.documento.idImgDocumentoFront &&
          element.documento.idImgDocumentoBack &&
          element.documento.docSubmitted) ||
          element.annullato ||
          element.annullatoFe
      })

      var checkFileIsUploadedNewExecut = self.newExecutAdded.every(function (element) {
        return element.documento && element.documento.idImgDocumentoFront && element.documento.idImgDocumentoBack && element.documento.docSubmitted
      })

      var testSesso = self.newExecutAdded.filter(function (element) {
        return !!!element.cf
      }).every(function (sex) {
        return sex.sesso != null;
      })
      // in tutti i casi (cliente = azienda o persona) deve essere presente almeno un esecutore

      var leastOne = self.model.length > 0 || self.newExecutAdded.length > 0;

      var testComponentValid = $scope.esecutoreForm.$valid &&
        checkFileIsUploadedModel &&
        checkFileIsUploadedNewExecut &&
        testSesso && leastOne;

      console.log("Il form esecutore è:", testComponentValid);

      self.newExecutAddFn({
        nuovoEsecutore: self.newExecutAdded
      })



      self.exportValidationComponent({
        valid: testComponentValid
      })

    }, 500)
  }


  self.handleChangeClassicVersion = function (name, value, indice) {
    console.log(name)
    switch (name) {
      case 'number-document':
        self.model[indice].documento.numero = value
        break;

      case 'dataScadenza':
        self.model[indice].documento.dataScadenza = value;
        break;

      case 'dataRilascio':
        self.model[indice].documento.dataRilascio = value;
        break;

      default:
        break;
    }
    validateComponent();
  }

  self.handleChangeClassicVersionNewExecut = function (name, value, indice) {
    console.log(name)
    switch (name) {
      case 'number-document':
        self.newExecutAdded[indice].documento.numero = value
        break;

      case 'dataScadenza':
        self.newExecutAdded[indice].documento.dataScadenza = value;
        break;

      case 'dataRilascio':
        self.newExecutAdded[indice].documento.dataRilascio = value;
        break;

      default:
        break;
    }
    validateComponent();
  }

  self.addEsecutore = function () {
    var newExecut = createNewExecut();
    self.newExecutAdded.push(newExecut)
    validateComponent();
  }

  var createNewExecut = function (dateOfRest) {
    var newExecut = {
      cf: dateOfRest && dateOfRest.cf || null,
      cognome: dateOfRest && dateOfRest.cognome || null,
      data: dateOfRest && dateOfRest.data || null,
      datiNascita: {
        cap: null,
        cittadinanza: dateOfRest && dateOfRest.datiNascita.cittadinanza || null,
        comune: dateOfRest && dateOfRest.datiNascita.comune || null,
        indirizzo: null,
        nazione: dateOfRest && dateOfRest.datiNascita.nazione || null,
        provincia: dateOfRest && dateOfRest.datiNascita.provincia || null
      },
      description: "esecutore",
      documento: dateOfRest && Documento.build(dateOfRest.documento) || Documento.build(),
      domicilio: dateOfRest && dateOfRest.domicilio || null,
      domicilioDiverso: dateOfRest && dateOfRest.domicilioDiverso || false,
      editable: false,
      id: null,
      ndg: dateOfRest && dateOfRest.ndg || null,
      nome: dateOfRest && dateOfRest.nome || null,
      pep: {
        carica: self.domini.carica,
        origineFondi: self.domini.origineFondi,
        relazione: self.domini.relazione,
        id: "pep_base",
        description: "pep_base",
        visible: false,
        editable: false,
        pep: false,
        origineFondiDescr: null,
        paeseOrigine: null,
        pepFinanziamenti: false,
        relazioneDescr: null
      },
      ragioneSociale: null,
      ruolo: self.domini.ruolo,
      ruoloDescr: null,
      sesso: dateOfRest && dateOfRest.sesso || null,
      sedeLegale: Sede.build(dateOfRest && dateOfRest.sedeLegale),
      visible: false,
      isEstero: dateOfRest && dateOfRest.isEstero
    }
    return newExecut;
  }

  self.removeDefault = function (indice) {
    self.model.splice(indice, 1);
    validateComponent();
  }

  self.removeExecutAdded = function (indice) {
    self.newExecutAdded.splice(indice, 1);
    validateComponent();
  }

  self.verifyDate = function (indice, init) {
    if (!init) {
      if (indice == self.newExecutAdded.length - 1 && self.newExecutAdded[indice].cf && checkIfExecutIsPresent(self.newExecutAdded[indice].cf)) {

        return

      }
    }
    var sesso = null;
    if (!self.newExecutAdded[indice].cf) {
      sesso = self.newExecutAdded[indice].sesso;
    } else {
      var giornoNascita = self.newExecutAdded[indice].cf && self.newExecutAdded[indice].cf.substring(9, 11);
      sesso = giornoNascita > 40 ? 'F' : 'M'
    }
    calculateFakeCf(indice)
    var codCat = "";
    if (self.newExecutAdded[indice].datiNascita.provincia != 'EE') {
      codCat = self.newExecutAdded[indice].datiNascita.comune &&
        self.mapComuni.find(function (element) {
          return element.nome.toUpperCase() == self.newExecutAdded[indice].datiNascita.comune.toUpperCase()
        }).codiceCatastale;
    } else {
      codCat = self.listaNazioni.find(function (element) {
        return element.name.toUpperCase() == self.newExecutAdded[indice].datiNascita.nazione.toUpperCase();
      }).value
    }
    self.testDati[indice] = validationService.checkCfWithFieds(
      self.newExecutAdded[indice].cf,
      self.newExecutAdded[indice].nome,
      self.newExecutAdded[indice].cognome,
      self.newExecutAdded[indice].data,
      sesso,
      codCat
    );
    validateComponent();
  };

  self.setDataNascita = function (indice, value) {
    self.newExecutAdded[indice].data = value;
    self.verifyDate(indice);
    validateComponent();
  }

  self.creaComuniNascita = function (indice, provincia) {


    if (provincia != 'EE') {
      self.listaComuniNascita[indice] = self.mapComuni
        .filter(function (comune) {
          return comune.sigla == provincia;
        });
      if (self.newExecutAdded && self.newExecutAdded[indice] && self.newExecutAdded[indice].datiNascita.nazione) {
        self.newExecutAdded[indice].datiNascita.nazione = 'Italia';
      }

    }
    validateComponent();
  }

  self.getEndDate = function (dataRilascio, index, value) {
    if (dataRilascio) {
      var tipoDocumento = self.model[index].documento.tipo;
      var dataNascita = self.model[index].data;
      var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
      var startYear = moment(dataRilascio).format("YYYY");
      var startDay = moment(dataRilascio).format("DD");
      var startMonth = moment(dataRilascio).format("MM");

      var endDate = moment(dataRilascio)
        .add(10, "years")
        .format("DD/MM/YYYY");

      if (
        tipoDocumento === propMap["DOC_TYPE_CAI"] ||
        tipoDocumento === propMap["DOC_TYPE_NCE"] ||
        tipoDocumento === propMap["DOC_TYPE_CIE"] ||
        tipoDocumento === propMap["DOC_TYPE_CAE"] ||
        tipoDocumento === propMap["DOC_TYPE_PAT"] ||
        tipoDocumento === propMap['DOC_TYPE_PAM'] ||
        tipoDocumento === propMap['DOC_TYPE_UCO'] ||
        self.isM17Map
      ) {
        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
        var birthYear = moment(dataNascita).format("YYYY");
        var birthDay = moment(dataNascita).format("DD");
        var birthMonth = moment(dataNascita).format("MM");

        if (birthMonth == '02' && birthDay == '29') {
          birthMonth = '03';
          birthDay = '01';
        }

        var futureBirthDay = moment(
          birthDay + "/" + birthMonth + "/" + startYear,
          "DD/MM/YYYY"
        )
          .add(10, "years")
          .format("DD/MM/YYYY");
        //console.log("Compleanno Futuro: " + futureBirthDay);

        var daysDiff = moment
          .duration(
            moment(endDate, "DD/MM/YYYY").diff(
              moment(futureBirthDay, "DD/MM/YYYY")
            )
          )
          .asDays();

        var expiryDate;
        if (daysDiff <= 0) {
          expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
        } else {
          expiryDate = moment(
            birthDay + "/" + birthMonth + "/" + startYear,
            "DD/MM/YYYY"
          )
            .add(11, "years")
            .format("DD/MM/YYYY");
        }

        while (
          (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
          ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
          expiryDate = moment(
            expiryDate,
            "DD/MM/YYYY"
          )
            .add(10, "years")
            .format("DD/MM/YYYY");
        }

        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        expiryDate = moment(expiryDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19

        if ($scope.esecutoreForm && $scope.esecutoreForm[value] && moment.duration(moment(self.model[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
          $scope.esecutoreForm[value].$valid = false;
        }
        if ($scope.esecutoreForm && $scope.esecutoreForm[value] && moment.duration(moment(self.model[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
          $scope.esecutoreForm[value].$valid = false;
          $scope.esecutoreForm[value].$setValidity("dataScadenza", false);
        } else {
          $scope.esecutoreForm && $scope.esecutoreForm[value] && $scope.esecutoreForm[value].$setValidity("dataScadenza", true);
        }
        return expiryDate;
      } else {
        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        endDate = moment(endDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19
        if (
          moment
            .duration(
              moment(
                self.model[index].documento.dataScadenza,
                "DD/MM/YYYY"
              ).diff(moment(endDate, "DD/MM/YYYY"))
            )
            .asDays() > 0
        ) {
          $scope.esecutoreForm[value].$valid = false;
        }
        return endDate;
      }
    } else {
      return moment(self.today, "DD/MM/YYYY")
        .add(10, "years")
        .format("DD/MM/YYYY");
    }

  };

  self.getEndDateNewExecut = function (dataRilascio, index, value) {
    if (dataRilascio) {
      var tipoDocumento = self.newExecutAdded[index].documento.tipo;
      var dataNascita = self.newExecutAdded[index].data;
      var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
      var startYear = moment(dataRilascio).format("YYYY");
      var startDay = moment(dataRilascio).format("DD");
      var startMonth = moment(dataRilascio).format("MM");

      var endDate = moment(dataRilascio)
        .add(10, "years")
        .format("DD/MM/YYYY");

      if (
        tipoDocumento === propMap["DOC_TYPE_CAI"] ||
        tipoDocumento === propMap["DOC_TYPE_NCE"] ||
        tipoDocumento === propMap["DOC_TYPE_CIE"] ||
        tipoDocumento === propMap["DOC_TYPE_CAE"] ||
        tipoDocumento === propMap["DOC_TYPE_PAT"] ||
        tipoDocumento === propMap['DOC_TYPE_PAM'] ||
        tipoDocumento === propMap['DOC_TYPE_UCO'] ||
        self.isM17Map
      ) {
        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
        var birthYear = moment(dataNascita).format("YYYY");
        var birthDay = moment(dataNascita).format("DD");
        var birthMonth = moment(dataNascita).format("MM");

        if (birthMonth == '02' && birthDay == '29') {
          birthMonth = '03';
          birthDay = '01';
        }

        var futureBirthDay = moment(
          birthDay + "/" + birthMonth + "/" + startYear,
          "DD/MM/YYYY"
        )
          .add(10, "years")
          .format("DD/MM/YYYY");
        //console.log("Compleanno Futuro: " + futureBirthDay);

        var daysDiff = moment
          .duration(
            moment(endDate, "DD/MM/YYYY").diff(
              moment(futureBirthDay, "DD/MM/YYYY")
            )
          )
          .asDays();

        var expiryDate;
        if (daysDiff <= 0) {
          expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
        } else {
          expiryDate = moment(
            birthDay + "/" + birthMonth + "/" + startYear,
            "DD/MM/YYYY"
          )
            .add(11, "years")
            .format("DD/MM/YYYY");
        }

        while (
          (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
          ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
          expiryDate = moment(
            expiryDate,
            "DD/MM/YYYY"
          )
            .add(10, "years")
            .format("DD/MM/YYYY");
        }

        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        expiryDate = moment(expiryDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19

        if ($scope.esecutoreForm && $scope.esecutoreForm[value] && moment.duration(moment(self.newExecutAdded[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
          $scope.esecutoreForm[value].$valid = false;
        }
        if ($scope.esecutoreForm && $scope.esecutoreForm[value] && moment.duration(moment(self.newExecutAdded[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
          $scope.esecutoreForm[value].$valid = false;
          $scope.esecutoreForm[value].$setValidity("dataScadenza", false);
        } else {
          $scope.esecutoreForm && $scope.esecutoreForm[value] && $scope.esecutoreForm[value].$setValidity("dataScadenza", true);
        }
        return expiryDate;
      } else {
        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        endDate = moment(endDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19
        if (
          moment
            .duration(
              moment(
                self.newExecutAdded[index].documento.dataScadenza,
                "DD/MM/YYYY"
              ).diff(moment(endDate, "DD/MM/YYYY"))
            )
            .asDays() > 0
        ) {
          $scope.esecutoreForm[value].$valid = false;
        }
        return endDate;
      }
    } else {
      return moment(self.today, "DD/MM/YYYY")
        .add(10, "years")
        .format("DD/MM/YYYY");
    }

  };

  var setDefaulValue = function () {
    self.model && self.model.forEach(function (element, index) {
      self.supportModel.ruolo[index] = element.ruolo.find(function (sel) {
        return sel.selected == true;
      })
      self.supportModel.caricaIstituzionale[index] = element.pep.carica.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel.relazionePep[index] = element.pep.relazione.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel.originePatrimonio[index] = element.pep.origineFondi.find(function (sel) {
        return sel.selected == true;
      })
    })

    // set default value new element
    self.newExecutAdded && self.newExecutAdded.forEach(function (element, index) {
      self.supportnewExecutAdded.ruolo[index] = element.ruolo.find(function (sel) {
        return sel.selected == true;
      })
      self.supportnewExecutAdded.caricaIstituzionale[index] = element.pep.carica.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewExecutAdded.relazionePep[index] = element.pep.relazione.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewExecutAdded.originePatrimonio[index] = element.pep.origineFondi.find(function (sel) {
        return sel.selected == true;
      })
    })

  }

  self.searchEsecutore = function () {
    self.enableModalSearch = true;
    self.supportExecutModel = {}
    $("#footerInstant").css("z-index", "-1");
    $('.financial-leasing__footer').css("z-index", "-1");
    $timeout(function () {
      $modalService.openModal('ricercaEsecutore-modal');

    }, 200)


  }

  self.closeModal = function () {
    $modalService.closeModal('ricercaEsecutore-modal');
    self.enableModalSearch = false;
  }

  self.closeModalUploadDocument = function () {
    $modalService.closeModal('modalUploadDocument');
    self.enableModalDocument = false;
    self.esecutoreIesimo = Object.assign({});
    self.documentUpload = [];
    validateComponent();
  }

  self.addEsecutoreSearch = function (user) {
    $rootScope.disableDoubleClick = true;
    self.newExecutAdded = self.newExecutAdded && self.newExecutAdded.filter(function (esecutore) {
      return esecutore.cf != null;
    })
    self.enableLoaderButton = true;
    $financialApiService
      .getSearchRiUserG(user)
      .then(function (listAppCustomer) {
        if (listAppCustomer.success) {
          // controllo se l'user è estero
          listAppCustomer.appCustomerUser.metadata.riUserG.sedeLegale.stato = listAppCustomer.appCustomerUser.metadata.riUserG.sedeLegale.statoEsteso
          if (listAppCustomer.appCustomerUser.metadata.riUserG.isEstero) {
            var codCityOfBirth = self.listaNazioni.find(function (element) {
              return element.name.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.nazione.toUpperCase()
            }).value
            if (!listAppCustomer.appCustomerUser.metadata.riUserG.sesso) {
              listAppCustomer.appCustomerUser.metadata.riUserG.sesso = "m"
            }
            listAppCustomer.appCustomerUser.metadata.riUserG.cf = validationService.createCf(listAppCustomer.appCustomerUser.metadata.riUserG.nome, listAppCustomer.appCustomerUser.metadata.riUserG.cognome, listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.data, listAppCustomer.appCustomerUser.metadata.riUserG.sesso, codCityOfBirth)
          }
          // controllo se il cf è già presente in mappa
          var testExecutAdded = self.newExecutAdded && self.newExecutAdded.some(function (element) {
            return element.cf.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.cf.toUpperCase()
          })
          var testExecut = self.model && self.model.some(function (element) {
            return element.cf.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.cf.toUpperCase()
          })
          if (testExecutAdded || testExecut) {
            $rootScope.$broadcast("addAlert", {
              text: "ALREADY_ADDED"
            });
            $rootScope.disableDoubleClick = false;
            self.enableLoaderButton = false;
            return
          }
          var newUser = convertDateToExecut(listAppCustomer.appCustomerUser.metadata.riUserG)
          var newExecut = createNewExecut(newUser);
          self.model.push(newExecut);
          createListForNewEsecut();
          validateComponent();
        }
        $rootScope.disableDoubleClick = false;
        $modalService.closeModal('ricercaEsecutore-modal');
        self.enableModalSearch = false;
        self.enableLoaderButton = false;
      })
      .catch(function (error) {
        console.log(error);
        $rootScope.disableDoubleClick = false;
        $modalService.closeModal('ricercaEsecutore-modal');
        self.enableModalSearch = false;
        self.enableLoaderButton = false;
      })
  }

  self.enabledConfirm = function (value) {
    self.enabledConfirmButton = !!value;
    self.userSelected = value;
  }

  var convertDateToExecut = function (user) {
    var temp = {
      nome: user.nome,
      cognome: user.cognome,
      cf: user.cf,
      data: user.datiNascita.data,
      datiNascita: user.datiNascita,
      sedeLegale: user.sedeLegale,
      ndg: user.ndg,
      domicilio: user.domicilio,
      domicilioDiverso: user.domicilioDiverso,
      isEstero: user.isEstero,
      documento: user.documento
    }

    return temp;

  }

  var dealerUser = function () {
    if ($portalService.isAru()) {

      $userService.getDealerUser()
        .then(function (dealer) {
          if (dealer) {
            self.dealerUser = dealer;
          }
        });
    }
  }

  self.openModalDocument = function (esecutore) {
    if (!esecutore.cf && esecutore.isEstero) {
      var codCityOfBirth = self.listaNazioni.find(function (element) {
        return element.name.toUpperCase() == esecutore.datiNascita.nazione.toUpperCase()
      }).value
      esecutore.sesso = "m";
      esecutore.cf = validationService.createCf(esecutore.nome, esecutore.cognome, esecutore.data, esecutore.sesso, codCityOfBirth)

    }
    self.esecutoreIesimo = esecutore;
    self.enableModalDocument = true;
    if (self.esecutoreIesimo.documento.idImgDocumentoFront) {
      var temp = {
        name: '',
        type: "imgDocument",
        selected: false,
        side: "front",
        typeDocument: self.esecutoreIesimo.documento.tipo,
        downloadLink: "",
        cdDoc: self.esecutoreIesimo.documento.tipo,
        id: self.esecutoreIesimo.documento.idImgDocumentoFront,
        imgDocumentoFront: self.esecutoreIesimo.documento.imgDocumentoFront,
        downloadKey: self.esecutoreIesimo.documento.idImgDocumentoFront
      };
      self.documentUpload.push(temp);
    }

    if (self.esecutoreIesimo.documento.idImgDocumentoBack) {
      var temp = {
        name: '',
        type: "imgDocument",
        selected: false,
        side: "back",
        typeDocument: self.esecutoreIesimo.documento.tipo,
        downloadLink: "",
        cdDoc: self.esecutoreIesimo.documento.tipo,
        id: self.esecutoreIesimo.documento.idImgDocumentoBack,
        imgDocumentoFront: self.esecutoreIesimo.documento.imgDocumentoBack,
        downloadKey: self.esecutoreIesimo.documento.idImgDocumentoBack
      };
      self.documentUpload.push(temp);
    }

    $timeout(function () {
      $modalService.openModal('modalUploadDocument')
    }, 300)
  }

  /* inizio sezione per caricamento documenti */
  self.changeUploadMode = function () {
    self.esecutoreIesimo.documento.idImgDocumentoFront = "";
    self.esecutoreIesimo.documento.idImgDocumentoBack = "";
    self.documentUpload = [];

  }
  self.callStartMobile = function () {
    if (self.uploadDocumentSelect == 'smartphone') {
      self.startUploadDocumentMobile();
    } else {
      self.startUploadDocument();
    }

  };

  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index, privacy, type, side) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ?
        arguments[3] :
        false;
    if (item) {
      self.uploadData = item;
    }
    self.typeTempDocument = type;
    self.isPrivacyUpload = privacy;
    self.uploadDocumenti = document;
    self.currentCodeTypeNameIndex = index;
    self.sideUploaded = side;
  };
  self.finalUpload = function (item) {
    console.log("calling finalUpload");
    var url =
      $configService.getAppConfig().url +
      "/uni/upload/service-infos///FINANCIAL_PD";

    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    var fileFront = document.querySelector(
      "#uploadInput_front").files[0];
    var fileBack = document.querySelector(
      "#uploadInput_back").files[0];
    var file;
    if (fileFront) {
      file = fileFront;
    } else {
      file = fileBack;
    }
    var tipo = self.esecutoreIesimo.documento.tipo;
    var reader = new FileReader();
    var fronte = self.sideUploaded == "front" ? true : false;
    reader.onload = function (event) {
      var formData = new FormData();
      jQuery("#uploadInput_front").val("");
      jQuery("#uploadInput_back").val("");
      appendToForm(formData, "file", file);
      appendToForm(formData, "type", "GENERAL_PERSONAL_DOCUMENTS");
      appendToForm(formData, "cdDoc", tipo);
      appendToForm(formData, "filename", file.name);
      appendToForm(formData, "idPratica", self.startQuestionario.id);
      appendToForm(formData, "personal", true);
      appendToForm(formData, "fronte", fronte);
      appendToForm(formData, "cfSoggetto", self.esecutoreIesimo.cf);
      appendToForm(formData, "ndgSoggetto", self.esecutoreIesimo.ndg);

      $uniService
        .uploadDocOnAdv(formData)
        .then(function (response) {
          if (!response.success) {
            self.visualProgBarDoc = false;
            self.disabledForUploadingInProgress = false;
            if (self.sideUploaded == "front") {
              self.disabeldUploadFront = false;
            } else {
              self.disabeldUploadBack = false;
            }
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_UPLOAD"
            });

            return;
          }

          $timeout(function () {
            var temp = {
              name: file.name,
              type: "imgDocument",
              selected: false,
              side: self.sideUploaded,
              typeDocument: self.esecutoreIesimo.documento.tipo,
              downloadLink: "",
              cdDoc: self.esecutoreIesimo.documento.tipo,
              id: response.id,
              imgDocumentoFront: response.downloadKey,
              downloadKey: response.downloadKey
            };


            if (self.sideUploaded == "front") {
              self.disabeldUploadFront = true;
            } else {
              self.disabeldUploadBack = true;
            }

            self.documentUpload.push(temp);

            self.documentUpload = self.documentUpload.filter(function (
              elem
            ) {
              return elem.name != "";
            });
            self.disableInput = false;

            self.visualProgBarDoc = false;
            if (self.sideUploaded == "front") {
              self.esecutoreIesimo.documento.idImgDocumentoFront = response.downloadKey
            } else {
              self.esecutoreIesimo.documento.idImgDocumentoBack = response.downloadKey;
            }

            $timeout(function () {
              self.disabledForUploadingInProgress = false;
            }, 1000);
          }, 40);
        })
        .catch(function (error) {
          self.visualProgBarDoc = false;
          self.disabledForUploadingInProgress = false;
          if (self.sideUploaded == "front") {
            self.disabeldUploadFront = false;
          } else {
            self.disabeldUploadBack = false;
          }
        });

    };
    if (file) {
      reader.readAsArrayBuffer(file);
    }
  };
  self.uploader.onAfterAddingFile = function (fileItem) {
    self.disabledForUploadingInProgress = true;
    console.log("fileItem", fileItem);
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_back").val("");
      jQuery("#uploadInput_front").val("");
    }
    var fileName = fileItem.file.name;
    if (
      fileName.toLowerCase().indexOf(".png") > -1 ||
      fileName.toLowerCase().indexOf(".jpg") > -1 ||
      fileName.toLowerCase().indexOf(".jpeg") > -1 ||
      fileName.toLowerCase().indexOf(".tiff") > -1 ||
      fileName.toLowerCase().indexOf(".pdf") > -1 ||
      fileName.toLowerCase().indexOf(".zip") > -1
    ) {
      self.uploader.queue[0].progress = 100;

      self.visualProgBarDoc = true;

      $timeout(function () {
        self.progresso = 100;
      }, 500);
    } else {
      fileItem.remove();
      jQuery("#uploadInput_back").val("");
      jQuery("#uploadInput_front").val("");
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED",
      });
      self.disabledForUploadingInProgress = false;
    }
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disableInput = true;
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (
    fileItem,
    response,
    status,
    headers
  ) { };

  self.uploader.onErrorItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onErrorItem", fileItem, response, status, headers);
    jQuery("#uploadInput_back").val("");
    jQuery("#uploadInput_front").val("");
    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disableInput = false;
    $timeout(function () {
      self.visualProgBarDoc = false;
    }, 4000);

    fileItem.remove();
    jQuery("#uploadInput_back").val("");
    jQuery("#uploadInput_front").val("");
  };

  self.uploader.onCancelItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {

    }
    self.uploader.queue = [];

    self.disableInput = false;
    $timeout(function () {
      self.visualProgBarDoc = false;

      self.disabledForUploadingInProgress = false;
    }, 4000);
    jQuery("#uploadInput_back").val("");
    jQuery("#uploadInput_front").val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    self.uploading = false;
  };

  self.check = function (el) {
    el.selected = !el.selected;
  };

  self.trashCanEnabledDoc = function () {
    return self.documentUpload.some(function (element) {
      return element.selected == true;
    })
  }

  self.deletePrivacyDocument = function () {
    self.progresso = 100;

    self.visualProgBarDoc = true;
    var temp = self.documentUpload.filter(function (elem) {
      return elem.selected == true;
    });
    temp.forEach(function (element) {
      $simulationService
        .deleteChecklistFileAdv(element.id)
        .then(function (response) {
          console.log(response);
          self.progresso = 0;
          if (response.success) {
            self.documentUpload = self.documentUpload.filter(function (
              elem
            ) {
              return elem.selected != true
            });

            if (element.side == 'front') {
              self.esecutoreIesimo.documento.idImgDocumentoFront = ""
              self.disabeldUploadFront = false;
            } else {
              self.esecutoreIesimo.documento.idImgDocumentoBack = ""
              self.disabeldUploadBack = false;
            }

            self.uploadOk = false;
          }
          self.visualProgBarDoc = false;
        })
        .catch(function (error) {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_TEC",
          });
        });

    });
  }

  self.downloadFiles = function (file) {
    var url = "/uni/downloadDocAdv/service-infos/";
    if (!self.startQuestionario.readOnly) {
      var input = {
        downloadKey: file.downloadKey
      }
    } else {
      var input = {
        downloadKey: file
      }
    }
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })
  }

  self.startUploadDocument = function () {
    self.enableLoader = true;
    $rootScope.$broadcast("pageLoader", {
      action: "OPEN",
    });
    var person = {
      cf: self.esecutoreIesimo.cf,
      nome: self.esecutoreIesimo.nome && self.esecutoreIesimo.nome.toUpperCase(),
      cognome: self.esecutoreIesimo.cognome &&
        self.esecutoreIesimo.cognome.toUpperCase(),
      telefono: self.dealerUser.tel,
      documento: {
        tipo: self.esecutoreIesimo.documento.tipo,
      },
    };

    self.intervalOfRepeatListenMobileCapture = 0;
    var numberOfIteration = 0;
    var person = [Pf.build(person)];


    $financialApiService
      .startMobileCaptureAdv(
        person,
        self.vendorPhone,
        false,
        self.startQuestionario.id,
        self.esecutoreIesimo.cf,
        self.startQuestionario.metadataAdv.cliente.common.cf
      )
      .then(function (response) {
        if (response.success) {
          var inputListenMobileCapture = {
            id: response.id,
          };

          var inputForCallBackMobileCapture = {
            id: response.id,
            contingencyUpload: self.documentUpload,
            flagCallFE: "false"
          };

          $instantService
            .callbackMobileCapture(inputForCallBackMobileCapture)
            .then(function (response) {
              if (!response.success) {
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
              } else {
                self.intervalOfRepeatListenMobileCapture = setInterval(
                  function () {
                    $instantService
                      .listenMobileCapture(inputListenMobileCapture)
                      .then(function (response) {
                        numberOfIteration++;
                        if (
                          response.success &&
                          response.details.uploadCompleted
                        ) {
                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE",
                          });
                          /* uno */

                          self.esecutoreIesimo.documento.dataRilascio = self.esecutoreIesimo.documento.dataRilascio ? self.esecutoreIesimo.documento.dataRilascio : response.ocrResponse.documento.dataRilascio;
                          self.esecutoreIesimo.documento.dataScadenza = self.esecutoreIesimo.documento.dataScadenza ? self.esecutoreIesimo.documento.dataScadenza : response.ocrResponse.documento.dataScadenza;
                          self.esecutoreIesimo.documento.luogoEsteso = self.esecutoreIesimo.documento.luogoEsteso ? self.esecutoreIesimo.documento.luogoEsteso : response.ocrResponse.documento.luogoEsteso;
                          self.esecutoreIesimo.documento.enteRilascio.name = self.esecutoreIesimo.documento.enteRilascio.name ? self.esecutoreIesimo.documento.enteRilascio.name : response.ocrResponse.documento.enteRilascio && response.ocrResponse.documento.enteRilascio.name;
                          self.esecutoreIesimo.documento.provincia = self.esecutoreIesimo.documento.provincia ? self.esecutoreIesimo.documento.provincia : response.ocrResponse.documento.provincia;
                          self.esecutoreIesimo.documento.numero = self.esecutoreIesimo.documento.numero ? self.esecutoreIesimo.documento.numero : response.ocrResponse.documento.numero;

                          $rootScope.$broadcast("addAlert", {
                            text: "MSG_SEND_FILE_OK"
                          });
                          self.esecutoreIesimo.documento.docSubmitted = true;
                          self.closeModalUploadDocument();

                        }
                        if (numberOfIteration >= 50) {
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE"
                          });

                          $rootScope.$broadcast("addAlert", {
                            text: "ERROR_TIMEOUT_LISTEN_MOBILE"
                          });

                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                        }
                        console.log(
                          "Numero di iterazioni",
                          numberOfIteration
                        );
                        response.ocrResponse.documento.luogoEsteso &&
                          self.upgradeList({
                            comune: self.esecutoreIesimo.documento.luogoEsteso.nome,
                          });
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.enableLoader = false;
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                      });
                  },
                  10000
                );
              }
            })
            .catch(function (error) {
              console.log(error);
              self.enableLoader = false;
              $rootScope.$broadcast("pageLoader", {
                action: "CLOSE",
              });

              $rootScope.$broadcast("addAlert", {
                text: "ERROR_TIMEOUT_LISTEN_MOBILE",
              });
            });
        } else {
          $rootScope.$broadcast("pageLoader", {
            action: "CLOSE",
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        self.showLoader = false;
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE",
        });
      });


  };

  self.startUploadDocumentMobile = function () {
    self.enableLoader = true;
    $rootScope.$broadcast("pageLoader", {
      action: "OPEN",
    });
    self.documentUpload = [];
    var person = {
      cf: self.esecutoreIesimo.cf,
      nome: self.esecutoreIesimo.nome && self.esecutoreIesimo.nome.toUpperCase(),
      cognome: self.esecutoreIesimo.cognome &&
        self.esecutoreIesimo.cognome.toUpperCase(),
      telefono: self.dealerUser.tel,
      documento: {
        tipo: self.esecutoreIesimo.documento.tipo,
      },
    };

    self.intervalOfRepeatListenMobileCapture = 0;
    var numberOfIteration = 0;
    var person = [Pf.build(person)];
    var listOfDocument = [{
      id: "imgDocument",
      order: 2,
      fronteRetro: true,
      documentType: null,
      labelName: null,
      labelDescription: null,
      label: "DOC_IDENTITA_LBL",
      mocaDocumentTypes: [
        "identita-fronte",
        "identita-retro"
      ]
    }]
    $financialApiService
      .startMobileCaptureAdv(
        person,
        self.vendorPhone,
        true,
        self.startQuestionario.id,
        self.esecutoreIesimo.cf,
        self.startQuestionario.metadataAdv.cliente.common.cf,
        listOfDocument
      )
      .then(function (response) {
        if (response.success) {
          var inputListenMobileCapture = {
            id: response.id,
          };

          self.intervalOfRepeatListenMobileCapture = setInterval(
            function () {
              $instantService
                .listenMobileCapture(inputListenMobileCapture)
                .then(function (response) {
                  numberOfIteration++;
                  if (
                    response.success &&
                    response.details.uploadCompleted
                  ) {
                    clearInterval(self.intervalOfRepeatListenMobileCapture);
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });
                    self.esecutoreIesimo.documento.dataRilascio = self.esecutoreIesimo.documento.dataRilascio ? self.esecutoreIesimo.documento.dataRilascio : response.ocrResponse.documento.dataRilascio;
                    self.esecutoreIesimo.documento.dataScadenza = self.esecutoreIesimo.documento.dataScadenza ? self.esecutoreIesimo.documento.dataScadenza : response.ocrResponse.documento.dataScadenza;
                    self.esecutoreIesimo.documento.luogoEsteso = self.esecutoreIesimo.documento.luogoEsteso ? self.esecutoreIesimo.documento.luogoEsteso : response.ocrResponse.documento.luogoEsteso;
                    self.esecutoreIesimo.documento.enteRilascio.name = self.esecutoreIesimo.documento.enteRilascio.name ? self.esecutoreIesimo.documento.enteRilascio.name : response.ocrResponse.documento.enteRilascio && response.ocrResponse.documento.enteRilascio.name;
                    self.esecutoreIesimo.documento.provincia = self.esecutoreIesimo.documento.provincia ? self.esecutoreIesimo.documento.provincia : response.ocrResponse.documento.provincia;
                    self.esecutoreIesimo.documento.numero = self.esecutoreIesimo.documento.numero ? self.esecutoreIesimo.documento.numero : response.ocrResponse.documento.numero;
                    self.documentUpload = [];
                    var temp = {
                      name: response.ocrResponse.documento.imgDocumentoFront,
                      type: "imgDocument",
                      selected: false,
                      side: "front",
                      typeDocument: self.esecutoreIesimo.documento.tipo,
                      cdDoc: self.esecutoreIesimo.documento.tipo,
                      id: response.ocrResponse.documento.idImgDocumentoFront,
                      downloadKey: response.ocrResponse.documento.idImgDocumentoFront
                    };

                    self.documentUpload.push(temp);
                    var temp = {
                      name: response.ocrResponse.documento.imgDocumentoBack,
                      type: "imgDocument",
                      selected: false,
                      side: "back",
                      typeDocument: self.esecutoreIesimo.documento.tipo,
                      cdDoc: self.esecutoreIesimo.documento.tipo,
                      id: response.ocrResponse.documento.idImgDocumentoBack,
                      downloadKey: response.ocrResponse.documento.idImgDocumentoBack
                    };
                    self.documentUpload.push(temp);
                    self.esecutoreIesimo.documento.imgDocumentoBack = response.ocrResponse.documento.imgDocumentoBack;
                    self.esecutoreIesimo.documento.imgDocumentoFront = response.ocrResponse.documento.imgDocumentoFront;
                    self.esecutoreIesimo.documento.idImgDocumentoFront = response.ocrResponse.documento.idImgDocumentoFront;
                    self.esecutoreIesimo.documento.idImgDocumentoBack = response.ocrResponse.documento.idImgDocumentoBack;
                    $rootScope.$broadcast("addAlert", {
                      text: "MSG_SEND_FILE_OK"
                    });
                    self.esecutoreIesimo.documento.docSubmitted = true;
                    self.closeModalUploadDocument();
                  }
                  if (numberOfIteration >= 50) {
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });

                    $rootScope.$broadcast("addAlert", {
                      text: "ERROR_TIMEOUT_LISTEN_MOBILE",
                    });

                    clearInterval(self.intervalOfRepeatListenMobileCapture);
                  }
                  console.log("Numero di iterazioni", numberOfIteration);
                  response.ocrResponse &&
                    self.upgradeList({
                      comune: self.esecutoreIesimo.documento.luogoEsteso.nome,
                    });
                })
                .catch(function (error) {
                  console.log(error);
                  self.enableLoader = false;
                  $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE",
                  });
                });
            },
            10000
          );
        } else {
          $rootScope.$broadcast("pageLoader", {
            action: "CLOSE",
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        self.showLoader = false;
        self.enableLoader = false;
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE",
        });
      });


  };



  /* fine sezione caricamento documenti */

  var checkIfExecutIsPresent = function (cf) {
    var testModel = self.model.some(function (element) {
      return element.cf.toUpperCase() == cf.toUpperCase();
    })

    var testNewAdd = self.newExecutAdded.slice(0, (self.newExecutAdded.length - 1))
      .some(function (element) {
        return element.cf.toUpperCase() == cf.toUpperCase();
      })

    if (testModel || testNewAdd) {
      $rootScope.$broadcast("addAlert", {
        text: "ALREADY_ADDED"
      });
      self.newExecutAdded.pop();

      return true;
    }

    return false;

  }

  self.fieldChanges = function (campo, valore, indice) {
    if (valore && valore.stato && valore.stato.name && valore.stato.name.toUpperCase() != 'ITALIA' && valore.stato.name.toUpperCase() != "CAMPIONE D'ITALIA") {
      self.cfIsNotRequired[indice] = true;
      self.newExecutAdded[indice].isEstero = true;
    } else {
      self.cfIsNotRequired[indice] = false;
      self.newExecutAdded[indice].isEstero = false;
    }
    calculateFakeCf(indice);
    validateComponent();
  }

  self.riabilita = function (index) {
    self.model[index].riattivatoFe = true;
    self.model[index].annullatoFe = false;
    validateComponent();
  }


  self.annulla = function (index) {
    self.model[index].annullatoFe = true;
    self.model[index].riattivatoFe = false;
    validateComponent();
  }

  var calculateFakeCf = function (indice) {
    if (self.newExecutAdded[indice] && !self.newExecutAdded[indice].cf && self.newExecutAdded[indice].nome && self.newExecutAdded[indice].cognome && self.newExecutAdded[indice].sesso && self.newExecutAdded[indice].datiNascita.nazione && self.newExecutAdded[indice].data && self.newExecutAdded[indice].isEstero) {
      var codCityOfBirth = self.listaNazioni.find(function (element) {
        return element.name.toUpperCase() == self.newExecutAdded[indice].datiNascita.nazione.toUpperCase()
      }).value
      self.newExecutAdded[indice].cf = validationService.createCf(self.newExecutAdded[indice].nome, self.newExecutAdded[indice].cognome, self.newExecutAdded[indice].data, self.newExecutAdded[indice].sesso, codCityOfBirth)
      self.verifyDate(indice);
    }
  }

  var createListForNewEsecut = function () {
    var indice = self.model.length - 1;

    self.listaNomeRilascio[indice] = Documento.getEntiRilascio(
      self.model[indice].documento.tipo
    );

    self.listaNomeComuni.rilascio[indice] = self.mapComuni
      .filter(function (comune) {
        return comune.sigla == self.model[indice].documento.provincia;
      });
  }

  var ricreaModelli = function () {
    self.newExecutAdded = self.model.filter(function (element) {
      return !element.ndg
    });
    self.newExecutAdded.forEach(function (element, index) {
      self.listaComuniNascita[index] = self.mapComuni
        .filter(function (comune) {
          return comune.sigla == element.datiNascita.provincia;
        });

      self.listaNomeRilascioNew[index] = element.documento && element.documento.tipo && Documento.getEntiRilascio(
        element.documento.tipo
      );
      if (element.datiNascita.provincia && element.datiNascita.provincia.toUpperCase() != 'EE' && element.datiNascita.provincia.toUpperCase() != 'SE') {
        self.verifyDate(index, true)
      }
    })
    self.model = self.model.filter(function (element) {
      return element.ndg
    });
    self.model.forEach(function (element, index) {
      if (element && !element.documento) {
        element.documento = Documento.build();
      }
      self.listaNomeRilascio[index] = element.documento && element.documento.tipo && Documento.getEntiRilascio(
        element.documento.tipo
      );
    })
    self.model && self.model.forEach(function (element) {
      if (element && element.sedeLegale && element.sedeLegale.stato) {
        element.sedeLegale.stato.name = element.sedeLegale.stato.name && element.sedeLegale.stato.name.toUpperCase();
      }
    })
  }


}